import { observable, action } from 'mobx'

class ViewStore{
    @observable
    snackbarState = false;

    @observable
    snackbarMessage = "";

    @action
    showSnackbar(message){
        this.snackbarState = true;
        this.snackbarMessage = message;
    }

    @action 
    hideSnackbar(){
        this.snackbarState = false;
        this.snackbarMessage = "";
    }
}

export default new ViewStore();